/* KI-Kennzeichnung, Art. 50 EU AI Act — Tap auf Touch, Escape schließt.
   Injiziert den Badge zusätzlich in die Teeinblue-Live-Vorschau
   (.tee-mockup-item), die das TIB-SDK client-seitig rendert.
   Pet Printed, Stand 01.08.2026 */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-ai-badge].is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
        var b = el.querySelector('.ai-badge__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Aktivierung in der CAPTURE-Phase, nicht im Bubbling:
     Der Badge sitzt im Produktbild zwischen fremden Handlern (Zoom-Modal
     <modal-opener>, TIB-SDK). Ein Handler dort kann das Event stoppen,
     bevor es document erreicht — auf Touch fehlt dann jede Reaktion,
     waehrend Desktop weiter per :hover funktioniert.
     Zusaetzlich pointerup: unterdrueckt ein fremdes touch-preventDefault
     das synthetische click-Event, bleibt der Tap sonst wirkungslos. */
  var lastPointerUpAt = -Infinity;

  function onActivate(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ai-badge__btn') : null;

    if (!btn) { closeAll(null); return; }

    e.preventDefault();
    e.stopPropagation();

    /* pointerup und click feuern beide fuer denselben Tap — den zweiten
       nur verschlucken, nicht dauerhaft sperren, sonst schluckt ein
       ausgebliebenes click-Event spaeter die Tastaturbedienung. */
    if (e.type === 'pointerup') {
      lastPointerUpAt = e.timeStamp;
    } else if (e.timeStamp - lastPointerUpAt < 1000) {
      return;
    }

    var wrap = btn.closest('[data-ai-badge]');
    if (!wrap) return;
    var open = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    closeAll(wrap);
  }

  document.addEventListener('pointerup', onActivate, true);
  document.addEventListener('click', onActivate, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* ---------- Injektion in die Teeinblue-Live-Vorschau ---------- */

  var uid = 0;

  function buildBadge() {
    uid += 1;
    var id = 'ai-badge-tib-tip-' + uid;
    var wrap = document.createElement('div');
    wrap.className = 'ai-badge ai-badge--compact';
    wrap.setAttribute('data-ai-badge', '');
    /* Tooltip-Text identisch mit snippets/ai-badge.liquid halten! */
    wrap.innerHTML =
      '<button type="button" class="ai-badge__btn" aria-describedby="' + id + '"' +
      ' aria-expanded="false" aria-label="Remarque : cette image produit a été créée avec une IA">' +
      '<span class="ai-badge__label">IA</span>' +
      '<span class="ai-badge__i" aria-hidden="true">i</span>' +
      '</button>' +
      '<span class="ai-badge__tip" id="' + id + '" role="tooltip">' +
      'Cette image produit a été créée avec une IA. Le motif présen' +
      'té est un exemple. Votre illustration sera réalisée individuellement à partir de votre photo.' +
      '</span>';
    return wrap;
  }

  function injectTibBadges() {
    /* Präsenz-Prüfung statt Einmal-Markierung: Das TIB-SDK ersetzt beim
       Re-Render die Kind-Elemente des Containers und entfernt dabei den
       Badge — er muss dann erneut injiziert werden.
       Varianten-/Modell-Thumbnails (.tee-thumbnail) bekommen KEINEN Badge,
       nur das große Vorschaubild im Slider (.tee-slide). */
    document.querySelectorAll('.tee-mockup-item').forEach(function (item) {
      if (item.closest('.tee-thumbnail')) return;
      if (!item.querySelector('.ai-badge')) {
        item.appendChild(buildBadge());
      }
    });
  }

  function startObserver() {
    injectTibBadges();
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        injectTibBadges();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
